import { Button, Group, Tooltip } from "@mantine/core";
import { FiInfo } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setActiveRoomColoringIdThunk } from "../../designThunk";
import { selectValidationToolbarMode } from "../DrofusOccurrenceValidationBarSelectors";
import { ModuleToolbarLabel } from "../ModuleToolbarLabel";
import "./DrofusOccurrenceValidationBar.css";
import { ModuleToolBarShell } from "../ModuleToolBarShell";
import { DrofusOccurrenceValidationSpecifiedArticlesSection } from "./DrofusOccurrenceValidationSpecifiedArticlesSection";
import { DrofusOccurrenceValidationStandardRoomSection } from "./DrofusOccurrenceValidationStandardRoomSection";

export const DrofusOccurrenceValidationBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { mode, occurrenceId, standardId } = useAppSelector(selectValidationToolbarMode);

  return (
    <ModuleToolBarShell>
      <div className="validation-toolbar">
        <div className="validation-toolbar-intro">
          <ModuleToolbarLabel module="ROOM_VALIDATION" />
          <span>Velg valideringstype</span>
        </div>
        <Group gap="xs" role="group" aria-label="Valideringstype">
          <Tooltip
            label={`Sammenligner artikler og antall i modellen med programmerte forekomster fra dRofus. Prosjektets unntatte artikler holdes utenfor.${!occurrenceId ? " Ingen resultater tilgjengelig." : ""}`}
            multiline w={320} withArrow position="bottom" openDelay={250} events={{ hover: true, focus: true, touch: false }}
          >
            <span tabIndex={!occurrenceId ? 0 : undefined}>
              <Button size="xs" variant={mode === "occurrence" ? "filled" : "neutral"}
                aria-pressed={mode === "occurrence"} disabled={!occurrenceId} rightSection={<FiInfo aria-hidden="true" />}
                onClick={() => { if (mode !== "occurrence") dispatch(setActiveRoomColoringIdThunk(occurrenceId)); }}>
                Forekomstvalidering
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            label={`Sammenligner rommets modellinnhold med standardrommet for RIE eller RIV. Vis samsvar som poeng eller status for manuell beslutning.${!standardId ? " Ingen resultater tilgjengelig." : ""}`}
            multiline w={320} withArrow position="bottom" openDelay={250} events={{ hover: true, focus: true, touch: false }}
          >
            <span tabIndex={!standardId ? 0 : undefined}>
              <Button size="xs" variant={mode === "standard" ? "filled" : "neutral"}
                aria-pressed={mode === "standard"} disabled={!standardId} rightSection={<FiInfo aria-hidden="true" />}
                onClick={() => { if (mode !== "standard") dispatch(setActiveRoomColoringIdThunk(standardId)); }}>
                Standardromvalidering
              </Button>
            </span>
          </Tooltip>
        </Group>
        <div className="validation-toolbar-section" role="group" aria-label="Visningsvalg">
          <span className="validation-toolbar-label">{mode === "occurrence" ? "Fargelegg etter" : "Disiplin og resultat"}</span>
          {mode === "occurrence"
            ? <DrofusOccurrenceValidationSpecifiedArticlesSection />
            : <DrofusOccurrenceValidationStandardRoomSection />}
        </div>
      </div>
    </ModuleToolBarShell>
  );
};
